/* EQ Food theme — small enhancements (everything works without JS) */
(function () {
  function init(root) {
    // Tabs
    root.querySelectorAll('[data-eq-tabs]').forEach(function (wrap) {
      var tabs = wrap.querySelectorAll('[role="tab"]');
      tabs.forEach(function (tab, i) {
        tab.addEventListener('click', function () { select(i); });
        tab.addEventListener('keydown', function (e) {
          if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {
            e.preventDefault();
            var n = (i + (e.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length;
            select(n); tabs[n].focus();
          }
        });
      });
      function select(n) {
        tabs.forEach(function (t, j) {
          var on = j === n;
          t.setAttribute('aria-selected', on ? 'true' : 'false');
          t.tabIndex = on ? 0 : -1;
          var panel = document.getElementById(t.getAttribute('aria-controls'));
          if (panel) panel.hidden = !on;
        });
      }
    });

    // Variant radios update price + button
    root.querySelectorAll('[data-eq-form]').forEach(function (form) {
      form.addEventListener('change', function (e) {
        var input = e.target;
        if (!input.matches('input[name="id"]')) return;
        var price = form.querySelector('[data-eq-price]');
        var compare = form.querySelector('[data-eq-compare]');
        var btn = form.querySelector('[data-eq-submit]');
        if (price) price.textContent = input.dataset.price;
        if (compare) {
          compare.textContent = input.dataset.compare || '';
          compare.hidden = !input.dataset.compare;
        }
        if (btn) {
          var available = input.dataset.available === 'true';
          btn.disabled = !available;
          btn.querySelector('[data-eq-label]').textContent = available ? (btn.dataset.add + ' · ' + input.dataset.price) : btn.dataset.soldout;
        }
        // Swap the photo to match the chosen flavour
        var scope = input.closest('[data-eq-product]') || document;
        var thumb = input.dataset.media && scope.querySelector('[data-eq-thumb="' + input.dataset.media + '"]');
        if (thumb) { thumb.click(); return; }
        var img = scope.querySelector('[data-eq-variant-img]');
        if (img && input.dataset.img && img.getAttribute('data-current') !== input.dataset.img) {
          img.classList.add('is-loading');
          var pre = new Image();
          pre.onload = pre.onerror = function () {
            img.removeAttribute('srcset');
            if (input.dataset.srcset) img.setAttribute('srcset', input.dataset.srcset);
            img.src = input.dataset.img;
            img.setAttribute('data-current', input.dataset.img);
            if (input.dataset.alt) img.alt = input.dataset.alt;
            img.classList.remove('is-loading');
          };
          pre.src = input.dataset.img;
        }
      });
    });

    // Quantity steppers
    root.querySelectorAll('[data-eq-qty]').forEach(function (wrap) {
      var input = wrap.querySelector('input');
      wrap.querySelectorAll('button').forEach(function (b) {
        b.addEventListener('click', function () {
          var v = parseInt(input.value || '1', 10) + parseInt(b.dataset.step, 10);
          input.value = Math.max(parseInt(input.min || '0', 10), v);
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });
    });

    // Product gallery thumbnails
    root.querySelectorAll('[data-eq-thumb]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var scope = btn.closest('[data-eq-product]') || document;
        var main = scope.querySelector('[data-eq-gallery-main]');
        if (!main) return;
        main.innerHTML = btn.querySelector('template').innerHTML;
        scope.querySelectorAll('[data-eq-thumb]').forEach(function (b) { b.setAttribute('aria-current', b === btn ? 'true' : 'false'); });
      });
    });

    // Shop box dialogs
    root.querySelectorAll('[data-eq-dialog-open]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var d = document.getElementById(btn.getAttribute('data-eq-dialog-open'));
        if (!d) return;
        if (typeof d.showModal === 'function') { d.showModal(); } else { d.setAttribute('open', ''); }
        document.documentElement.classList.add('eq-lock');
        d._opener = btn;
      });
    });
    root.querySelectorAll('dialog.eq-dialog').forEach(function (d) {
      function done() { document.documentElement.classList.remove('eq-lock'); if (d._opener) d._opener.focus(); }
      d.addEventListener('close', done);
      d.addEventListener('click', function (e) { if (e.target === d) d.close(); });
      d.querySelectorAll('[data-eq-dialog-close]').forEach(function (c) {
        c.addEventListener('click', function () { if (d.close) d.close(); else { d.removeAttribute('open'); done(); } });
      });
    });

    // Mobile menu
    root.querySelectorAll('[data-eq-menu]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var header = btn.closest('.eq-header');
        var open = header.getAttribute('data-open') === 'true';
        header.setAttribute('data-open', open ? 'false' : 'true');
        btn.setAttribute('aria-expanded', open ? 'false' : 'true');
      });
    });

    // Pause off-screen reels to save data
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          var v = en.target;
          if (en.isIntersecting) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
          else v.pause();
        });
      }, { threshold: 0.25 });
      root.querySelectorAll('.eq-reel video').forEach(function (v) { io.observe(v); });
    }
  }

  document.addEventListener('DOMContentLoaded', function () { init(document); });
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
